/** Absolute url of an in-app path, honouring the router basename (leading/trailing slashes optional). */
export function buildAppUrl(
  origin: string,
  basename: string | undefined,
  path: string
): string {
  const normalizedBase = basename ? basename.replace(/^\/+|\/+$/g, "") : "";
  const prefix = normalizedBase ? `/${normalizedBase}` : "";
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${origin}${prefix}${normalizedPath}`;
}
